export const FLYOUT_SIDEBAR_TYPES = {
  EDIT_PICKUP: 'EDIT_PICKUP',
  EDIT_PACKAGE: 'EDIT_PACKAGE',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  EDIT_CONSOLIDATION_ADDRESS: 'EDIT_CONSOLIDATION_ADDRESS',
  EDIT_CONSOLIDATION: 'EDIT_CONSOLIDATION',
  EDIT_CONTAINER: 'EDIT_CONTAINER',
  EDIT_PARTNER: 'EDIT_PARTNER',
  EDIT_ROUTE: 'EDIT_ROUTE',
}

export enum FlyoutSidebarTypes {
  EDIT_PICKUP = 'EDIT_PICKUP',
  EDIT_PACKAGE = 'EDIT_PACKAGE',
  EDIT_ADDRESS = 'EDIT_ADDRESS',
  EDIT_CONSOLIDATION_ADDRESS = 'EDIT_CONSOLIDATION_ADDRESS',
  EDIT_CONSOLIDATION = 'EDIT_CONSOLIDATION',
  EDIT_CONTAINER = 'EDIT_CONTAINER',
  EDIT_PARTNER = 'EDIT_PARTNER',
}
